import BaseService from '@src/services/BaseService'

class BusinessUnitsService extends BaseService {
    constructor() {
        super('business-units')
    }

    updateIntelligence(id, params) {
        return this.axios.post(`${this.getUrl()}/${id}/update-intelligence`, params)
    }

    activate(id, params) {
        return this.axios.post(`${this.getUrl()}/${id}/activate`, params)
    }

    inactivate(id, params) {
        return this.axios.post(`${this.getUrl()}/${id}/inactivate`, params)
    }
}

export default new BusinessUnitsService()
